module.exports = __webpack_public_path__ + "img/BM.69d3916f.svg";